import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, finalize, Observable, of, shareReplay, tap, throwError } from 'rxjs';
import { AccountModel } from '@store/models/account-model';
import { StorageUtilsService } from 'app/services/storage-utils/storage-utils.service';
import { BYPASS_AUTH_ERROR_HANDLING } from '@core/interceptors/http.interceptor';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private httpClient = inject(HttpClient);
    private _storageUtilsService = inject(StorageUtilsService);
    private authenticationCheck$?: Observable<AccountModel | null>;
    myClientAccounts = environment.ENDPOINTS.MY_CLIENT_ACCOUNTS_URL;
    subscription2Url = environment.ENDPOINTS.CLIENT_ACCOUNT_URL;
    accountUrl = environment.ENDPOINTS.ACCOUNT_URL;
    registerUrl = environment.ENDPOINTS.REGISTER_URL;
    GuestRegisterUrl = environment.ENDPOINTS.GUEST_REGISTER_URL;
    recaptchatUrl = environment.ENDPOINTS.RECAPTCHA_KEY_URL;



    /**
     * get clients accounts
     */
    getAccountsClients(): Observable<any> {
        const req = this.myClientAccounts;
        return this.httpClient.get<any>(req);
    }


    getAccountClientById(id): Observable<any> {
        const req = this.myClientAccounts + `/${id}`;
        return this.httpClient.get<any>(req);
    }


    /**
     * get the profil of the connected user
     */
    getAccount(): Observable<any> {
        const req = this.accountUrl;
        return this.httpClient.get<any>(req).pipe(tap(user => this._storageUtilsService.setUser(user)));
    }

    /**
     * Check the gateway-managed session and return the authenticated user.
     * Concurrent guards share the same request during initial navigation.
     */
    check(): Observable<AccountModel | null> {
        if (this.authenticationCheck$) {
            return this.authenticationCheck$;
        }

        const context = new HttpContext().set(BYPASS_AUTH_ERROR_HANDLING, true);

        this.authenticationCheck$ = this.httpClient.get<AccountModel>(this.accountUrl, { context }).pipe(
            tap((user) => {
                this._storageUtilsService.setUser(user);
            }),
            catchError((error: HttpErrorResponse) =>
                error.status === 401
                    ? of(null)
                    : throwError(() => error)
            ),
            finalize(() => {
                this.authenticationCheck$ = undefined;
            }),
            shareReplay({ bufferSize: 1, refCount: false }),
        );

        return this.authenticationCheck$;
    }

    /**
     * edit the profil user
     * @param profile the edited profil
     */
    updateProfil(profile): Observable<any> {
        const req = this.accountUrl;
        return this.httpClient.post<any>(req, profile);
    }

    /**
     * upload an image profil
     * @param image the image to set
     */
    uploadImage(image: File): Observable<any> {
        const req = this.accountUrl + '/profile-image';
        const uploadData = new FormData();
        uploadData.append('image', image, image.name);
        return this.httpClient.post(req, uploadData);
    }

    getGoogleRecaptchaKeySite(): Observable<any> {
        const req = this.recaptchatUrl;
        return this.httpClient.get<any>(req);
    }

    /**
 * edit password
 * @param password Password Account Model
 */
    editPassword(password: {
        currentPassword: any;
        newPassword: any;
    }): Observable<any> {
        const req = environment.ENDPOINTS.CHANGE_PASSWORD_URL;
        return this.httpClient.post(req, password);
    }

}
